import { useMutation } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { HeatmapRequest, HeatmapResponse } from '@/types/heatmap';

export function useHeatmapMutation() {
  return useMutation<HeatmapResponse, Error, HeatmapRequest>({
    mutationFn: async (req) => {
      const params: Record<string, string | number> = { metric: req.metric };
      if (req.since) params.since = req.since;
      if (req.until) params.until = req.until;
      if (req.bbox) params.bbox = req.bbox;
      if (req.grid_km != null) params.grid_km = req.grid_km;
      const resp = await api.get<HeatmapResponse>('/maps/heatmap', { params });
      return resp.data;
    },
  });
}
